import React, { useState } from 'react';
import PropTypes from 'prop-types';
import store from 'redux/store';
import { Provider } from 'react-redux';
import { FormContent } from 'client/components/FormContent';
import PageStatusView from 'client/components/PageStatusView';
import useClientTracking from 'client/hooks/useClientTracking';
import useInitForm from 'client/hooks/useInitForm';
import LoadingClient from 'common/components/LoadingClient';
import Head from 'common/components/Head';
import {
    useInitialInResultRedirect,
    useRedirectSponsorName,
    useCheckIsRedirectForm
} from 'common/hooks/useRedirectController';
import { useTagManager } from 'common/utils/tracking';
import ErrorBoundary from 'common/components/ErrorBoundary';
import { isInIframe } from 'api/common';

function ClientContent({ match, history }) {
    const {
        params: { id, routeSponsor }
    } = match;
    const isResult = match.params[0] === 'response';
    const inFrame = isInIframe();

    const { httpStatus, initData, initTrack, isLoading, refetch } = useInitForm({
        formId: id,
        sponsorId: routeSponsor
    });

    useCheckIsRedirectForm(initData, id, history);
    useInitialInResultRedirect({ history, isResult, id, initData });
    useRedirectSponsorName({ initData, history, routeSponsor });
    useTagManager(initTrack);
    useClientTracking({ formId: id, initTrack });

    if (initData) {
        return (
            <>
                <Head
                    title={initData.form.title}
                    description={initData.form.description}
                    imageUrl={initData.form.metaImageUrl}
                    favIcon={initData.favIcon}
                />
                <FormContent
                    history={history}
                    isResult={isResult}
                    routeSponsor={routeSponsor}
                    sponsorId={initData.sponsorId}
                    isInFrame={inFrame}
                    refetch={refetch}
                />
            </>
        );
    }

    if (initData === false) {
        return <PageStatusView status={httpStatus} />;
    }

    if (isLoading) {
        return <LoadingClient />;
    }

    return <LoadingClient />;
}

ClientContent.propTypes = {
    match: PropTypes.shape(),
    history: PropTypes.object
};

function Client({ match, history }) {
    const [reduxStore] = useState(() => {
        // 創建一個空的初始 store，稍後通過 dispatch 更新
        return store({
            pages: [],
            sections: [],
            fields: [],
            options: [],
            settings: { form: {}, fields: [], sections: [] },
            form: {},
            flag: {},
            hiddenFields: []
        });
    });

    return (
        <ErrorBoundary>
            <Provider store={reduxStore}>
                <ClientContent match={match} history={history} />
            </Provider>
        </ErrorBoundary>
    );
}

Client.propTypes = {
    match: PropTypes.shape(),
    history: PropTypes.object
};

export default Client;
